import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { AppDataProvider } from './state/AppData';
import { WebFeaturesProvider } from './state/WebFeatures';
import { GuestProvider } from './state/Guest';
import './styles.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } });
registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppDataProvider><GuestProvider><WebFeaturesProvider><App /></WebFeaturesProvider></GuestProvider></AppDataProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
